import type { FC } from "react";

import ChipRaw from "components/common/Chip";
import DatePickerRaw from "components/common/DatePicker";
import TableComponentRaw from "components/common/TableComponent";
import TopHeaderRaw from "components/common/TopHeader";
import HeaderRaw from "components/Header/Header";

/**
 * These are untyped JS components. Consumed from TS, their PropTypes make the
 * compiler infer every prop as required (labelClass, onSort, breadcrumbs, …).
 * Cast to a permissive FC once, here, rather than passing dozens of unused
 * props at every call site.
 */
export const CustomChip = ChipRaw as unknown as FC<any>;
export const TableComponent = TableComponentRaw as unknown as FC<any>;
export const TopHeader = TopHeaderRaw as unknown as FC<any>;
export const Header = HeaderRaw as unknown as FC<any>;
export const DatePicker = DatePickerRaw as unknown as FC<any>;
